<template>
  <article class="workspace-share">
    <h1>Envoyez ce lien à une personne pour l'ajouter à votre espace:</h1>
    <div class="link" @click="copyUrl">
      <p>{{ fullLink }}</p>
      <Icon icon="fas fa-copy" />
    </div>
  </article>
</template>

<script>
export default {
  props: {
    link: { required: true },
  },
  data() {
    return {};
  },
  methods: {
    copyUrl() {
      const el = document.createElement('textarea');
      el.value = this.fullLink;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.$toasted.show('Lien copié !');
    },
  },
  computed: {
    baseUrl() {
      return window.location.origin;
    },
    fullLink() {
      return this.baseUrl + this.link;
    },
  },
};
</script>

<style lang="scss" scoped src="./WorkspaceShare.scss"></style>
